import { useNavigate } from 'react-router-dom';

export default function BlogSection() {
  const navigate = useNavigate();

  const scrollToTopAndNavigate = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const articles = [
    {
      title: 'Guida Completa a Itaobuy Spreadsheet 2026',
      desc: 'Tutto quello che devi sapere su come funziona Itaobuy Spreadsheet, le categorie disponibili e come utilizzarlo al meglio per trovare prodotti.',
      path: '/articolo-guida-itaobuy-spreadsheet',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20data%20spreadsheet%20on%20screen%2C%20warm%20natural%20sunlight%20from%20window%2C%20cream%20desk%20surface%2C%20coffee%20cup%2C%20notebook%2C%20plants%2C%20italian%20modern%20interior%2C%20professional%20editorial%20photography%2C%20soft%20ambient%20light&width=800&height=500&seq=itaobuy-blog-v2-01&orientation=landscape',
      tag: 'Guida',
    },
    {
      title: 'Itaobuy Spreadsheet Scarpe: Guida ai Migliori Modelli',
      desc: 'Scopri la categoria Scarpe: sneakers, scarpe casual, sportive ed eleganti. Confronta prezzi, marche e valutazioni in un solo foglio.',
      path: '/articolo-itaobuy-spreadsheet-scarpe',
      img: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20sneakers%20and%20leather%20shoes%20beautifully%20arranged%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20photography%2C%20minimalist%20composition%2C%20warm%20beige%20and%20terracotta%20undertones%2C%20luxurious%20catalog%20display&width=800&height=500&seq=itaobuy-blog-v2-02&orientation=landscape',
      tag: 'Scarpe',
    },
    {
      title: 'Itaobuy Spreadsheet \u00e8 Sicuro? Analisi Completa',
      desc: 'Un\u2019analisi approfondita sulla sicurezza di itaobuy spreadsheet: cosa devi sapere, rischi da evitare e come usarlo in modo affidabile.',
      path: '/articolo-itaobuy-spreadsheet-sicurezza',
      img: 'https://readdy.ai/api/search-image?query=Trustworthy%20digital%20security%20concept%20with%20shield%20lock%20icon%20and%20clean%20modern%20workspace%20on%20cream%20desk%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20calm%20reassuring%20atmosphere%2C%20olive%20green%20accent%20details%2C%20minimalist%20composition&width=800&height=500&seq=itaobuy-blog-v2-03&orientation=landscape',
      tag: 'Sicurezza',
    },
    {
      title: 'Catalogo Categorie Itaobuy Spreadsheet 2026',
      desc: 'Panoramica completa di tutte le 14 categorie: Scarpe, Abbigliamento, Accessori, Borse, Profumi e molto altro.',
      path: '/articolo-itaobuy-spreadsheet-categorie',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20diverse%20fashion%20accessories%20and%20clothing%20items%20organized%20by%20category%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20catalog%20editorial%20style%2C%20italian%20fashion%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20product%20display&width=800&height=500&seq=itaobuy-blog-v2-04&orientation=landscape',
      tag: 'Categorie',
    },
    {
      title: 'Come Scegliere i Migliori Prodotti su Itaobuy',
      desc: 'Consigli pratici per navigare le categorie, confrontare alternative e trovare esattamente ci\u00f2 che cerchi in pochi minuti.',
      path: '/articolo-guida-itaobuy-spreadsheet',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20using%20laptop%20in%20bright%20airy%20italian%20cafe%2C%20warm%20natural%20light%2C%20cream%20walls%2C%20wooden%20table%2C%20plants%2C%20fashionable%20casual%20outfit%2C%20editorial%20lifestyle%20photography%2C%20soft%20aesthetic%2C%20authentic%20moment&width=800&height=500&seq=itaobuy-blog-v2-05&orientation=landscape',
      tag: 'Consigli',
    },
    {
      title: 'Itaobuy Spreadsheet per Principianti: Da Dove Iniziare',
      desc: 'Sei nuovo su itaobuy spreadsheet? Ecco la guida passo dopo passo per iniziare con il piede giusto senza perderti.',
      path: '/articolo-guida-itaobuy-spreadsheet',
      img: 'https://readdy.ai/api/search-image?query=Clean%20beginner%20friendly%20workspace%20with%20open%20notebook%20pen%20and%20laptop%20on%20cream%20desk%2C%20warm%20natural%20lighting%2C%20simple%20organized%20setup%2C%20guide%20concept%2C%20italian%20modern%20interior%2C%20soft%20minimalist%20photography%2C%20welcoming%20atmosphere&width=800&height=500&seq=itaobuy-blog-v2-06&orientation=landscape',
      tag: 'Principianti',
    },
    {
      title: 'Confronto Prezzi con Itaobuy Spreadsheet',
      desc: 'Come utilizzare itaobuy spreadsheet per confrontare prezzi, trovare le migliori offerte e risparmiare sui tuoi acquisti.',
      path: '/articolo-itaobuy-spreadsheet-scarpe',
      img: 'https://readdy.ai/api/search-image?query=Professional%20price%20comparison%20concept%20with%20laptop%20displaying%20charts%20and%20product%20cards%2C%20warm%20cream%20desk%20surface%2C%20soft%20daylight%2C%20elegant%20workspace%2C%20italian%20modern%20office%20aesthetic%2C%20minimalist%20editorial%20photography&width=800&height=500&seq=itaobuy-blog-v2-07&orientation=landscape',
      tag: 'Confronto',
    },
    {
      title: 'Le Migliori Sneakers su Itaobuy Spreadsheet',
      desc: 'Una selezione delle sneakers pi\u00f9 popolari e meglio recensite disponibili su itaobuy spreadsheet nel 2026.',
      path: '/articolo-itaobuy-spreadsheet-scarpe',
      img: 'https://readdy.ai/api/search-image?query=Trendy%20fashion%20sneakers%20in%20various%20colors%20beautifully%20displayed%20on%20warm%20cream%20pedestal%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20product%20photography%2C%20minimalist%20clean%20composition%2C%20warm%20beige%20background%2C%20premium%20catalog%20style&width=800&height=500&seq=itaobuy-blog-v2-08&orientation=landscape',
      tag: 'Sneakers',
    },
    {
      title: 'Itaobuy vs Altre Piattaforme: Quale Scegliere?',
      desc: 'Confronto dettagliato tra itaobuy spreadsheet e altre soluzioni per lo shopping online: vantaggi e svantaggi.',
      path: '/articolo-itaobuy-spreadsheet-categorie',
      img: 'https://readdy.ai/api/search-image?query=Modern%20comparison%20concept%20with%20two%20laptops%20side%20by%20side%20on%20cream%20desk%2C%20warm%20daylight%2C%20split%20screen%20idea%2C%20editorial%20business%20photography%2C%20italian%20office%20setting%2C%20minimalist%20composition%2C%20neutral%20warm%20tones&width=800&height=500&seq=itaobuy-blog-v2-09&orientation=landscape',
      tag: 'Confronto',
    },
    {
      title: 'Proteggi i Tuoi Acquisti: Guida alla Sicurezza',
      desc: 'Consigli essenziali per acquistare in sicurezza utilizzando itaobuy spreadsheet e proteggere i tuoi dati personali.',
      path: '/articolo-itaobuy-spreadsheet-sicurezza',
      img: 'https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20laptop%20showing%20lock%20icon%20and%20credit%20card%20on%20clean%20cream%20desk%2C%20warm%20natural%20lighting%2C%20trustworthy%20professional%20photography%2C%20minimalist%20composition%2C%20calm%20atmosphere&width=800&height=500&seq=itaobuy-blog-v2-10&orientation=landscape',
      tag: 'Sicurezza',
    },
    {
      title: 'Itaobuy Spreadsheet Aggiornato: Novit\u00e0 2026',
      desc: 'Tutte le ultime novit\u00e0 e gli aggiornamenti di itaobuy spreadsheet per il 2026: nuove categorie e prodotti.',
      path: '/articolo-itaobuy-spreadsheet-categorie',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20calendar%20and%20laptop%20on%20cream%20desk%20with%20warm%20sunlight%2C%20fresh%20start%20new%20year%20concept%2C%20italian%20modern%20workspace%2C%20soft%20editorial%20photography%2C%20minimalist%20composition%2C%20green%20plant%20accent%2C%20positive%20atmosphere&width=800&height=500&seq=itaobuy-blog-v2-11&orientation=landscape',
      tag: 'Aggiornamenti',
    },
    {
      title: 'Guida Taglie e Vestibilit\u00e0 su Itaobuy',
      desc: 'Come interpretare le taglie e trovare la vestibilit\u00e0 perfetta usando le informazioni disponibili su itaobuy spreadsheet.',
      path: '/articolo-itaobuy-spreadsheet-scarpe',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20clothing%20size%20guide%20concept%20with%20measuring%20tape%20and%20fabric%20swatches%20on%20cream%20surface%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20photography%2C%20minimalist%20composition%2C%20italian%20atelier%20aesthetic%2C%20soft%20beige%20tones&width=800&height=500&seq=itaobuy-blog-v2-12&orientation=landscape',
      tag: 'Guida',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-14 gap-6">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              Articoli &amp; Guide SEO
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-[500px]">
              Approfondimenti, guide e consigli su <strong>itaobuy spreadsheet</strong> per aiutarti a navigare al meglio. Tutti i contenuti sono originali e ottimizzati per la ricerca.
            </p>
          </div>
          <button
            onClick={() => scrollToTopAndNavigate('/articolo-guida-itaobuy-spreadsheet')}
            className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:border-foreground-400 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Vedi tutti gli articoli
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article, i) => (
            <button
              key={i}
              onClick={() => scrollToTopAndNavigate(article.path)}
              className="group text-left bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-background-300 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{article.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}